var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIconBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13270",
    "data-name": "Group 13270",
    transform: "translate(-839 -994)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_569",
    "data-name": "Ellipse 569",
    transform: "translate(839 994)",
    fill: "#014fe0",
    stroke: "#fff",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "delete_24dp_5F6368_FILL1_wght400_GRAD0_opsz24",
    d: "M162.711-823.736a1.74,1.74,0,0,1-1.276-.531,1.741,1.741,0,0,1-.531-1.276v-11.746a.873.873,0,0,1-.644-.26.873.873,0,0,1-.26-.644.873.873,0,0,1,.26-.643.874.874,0,0,1,.644-.26h3.614a.874.874,0,0,1,.26-.644.874.874,0,0,1,.644-.26h3.614a.874.874,0,0,1,.644.26.874.874,0,0,1,.26.644h3.614a.874.874,0,0,1,.644.26.873.873,0,0,1,.26.643.873.873,0,0,1-.26.644.873.873,0,0,1-.644.26v11.746a1.741,1.741,0,0,1-.531,1.276,1.74,1.74,0,0,1-1.276.531Zm2.711-3.614a.874.874,0,0,0,.644-.26.874.874,0,0,0,.26-.644v-6.325a.874.874,0,0,0-.26-.644.875.875,0,0,0-.644-.26.875.875,0,0,0-.644.26.874.874,0,0,0-.26.644v6.325a.874.874,0,0,0,.26.644A.874.874,0,0,0,165.421-827.35Zm3.614,0a.874.874,0,0,0,.644-.26.874.874,0,0,0,.26-.644v-6.325a.875.875,0,0,0-.26-.644.875.875,0,0,0-.644-.26.875.875,0,0,0-.644.26.875.875,0,0,0-.26.644v6.325a.874.874,0,0,0,.26.644A.874.874,0,0,0,169.035-827.35Z",
    transform: "translate(688 1842)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconBlue);
export default __webpack_public_path__ + "static/media/delete_icon_blue.7ed4b52d939d2aed271bf5be8736e5a6.svg";
export { ForwardRef as ReactComponent };